module.exports = __webpack_public_path__ + "img/icon_1_6.d0ff48e4.png";